import React from "react";

const BulletMarker = ({ icon, title, description, width }) => {
  return (
    <div
      style={{
        width: "90%",
        display: "flex",
        alignItems: "center",
        minHeight: width > 599 ? 50 : 100,
        marginBottom: 10,
        flexDirection: width > 599 ? "row" : "column",
      }}
    >
      <img alt="icon" src={icon} style={{ marginLeft: 10, marginRight: 20 }} />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: width > 599 ? "flex-start" : "center",
        }}
      >
        <div
          style={{
            fontSize: 13,
            fontWeight: "bold",
            textAlign: width > 599 ? "left" : "center",
          }}
        >
          {title}
        </div>
        <div
          style={{
            fontSize: 10,
            marginTop: 5,
            textAlign: width > 599 ? "left" : "center",
          }}
        >
          {description}
        </div>
      </div>
    </div>
  );
};
export default BulletMarker;
